// FutureLab
import { ChatListDataInterface } from '../components/chat/ChatListItemsMobile';
import { store } from '../ReduxRoot';
import { chatItemInFocus } from '../actions/chatItemInFocusActions';
import { LoggedInUserDetails } from '../reducers/index';
import { UserDetailsListItem } from '../model';
import { PinnedMessageItem } from '../components/chat/ChatListMenu';
import { pinnedMessageInFocus } from '../actions/pinnedMessageInFocusActions';
import { navigateToRoute } from './NavigateTo';
import { chatList } from '../actions/chatListActions';
import { isSameUserId, toUserId } from './UserId';
import { getUserDisplayName } from './UserDetails';

// 3rd Party
import _ from 'lodash';

export function navigateToChatRoom(chatRoom: ChatListDataInterface, route: string) {
	store.dispatch(chatItemInFocus(chatRoom));
	navigateToRoute(route);
}

export function openChatRoom(chatRoom: ChatListDataInterface) {
	store.dispatch(pinnedMessageInFocus(null));
	store.dispatch(chatItemInFocus(chatRoom));
}

export function getQueryResults(
	chatListsItems: ChatListDataInterface[],
	loggedInUserDetails: LoggedInUserDetails,
	userListProfilesDetails: UserDetailsListItem[],
	filterQuery: string
) {
	const loggedInUserId = toUserId(loggedInUserDetails.id);

	return chatListsItems.filter((chatList) => {
		const otherPersonInChatRoom = chatList?.participants?.find(
			(participant) => !isSameUserId(participant.userId, loggedInUserId)
		);
		const otherPersonInChatRoomDetails = userListProfilesDetails.find(
			(participant) => isSameUserId(participant.id, otherPersonInChatRoom?.userId)
		);

		const otherPersonInChatRoomDetailsFullName = getUserDisplayName(otherPersonInChatRoomDetails);

		if (!!chatList.isGroupChat) {
			return (
				(chatList?.name?.toLocaleLowerCase()?.includes(filterQuery.toLocaleLowerCase()) &&
					!!chatList.isGroupChat) ||
				!chatList.name
			);
		} else {
			return otherPersonInChatRoomDetailsFullName
				.toLocaleLowerCase()
				.includes(filterQuery.toLocaleLowerCase()) /* ||
				loggedInUserDetails.email.toLocaleLowerCase().includes(filterQuery.toLocaleLowerCase()) */;
		}
	});
}

export function getPinnedMessagesQueryResults(
	pinnedMessages: PinnedMessageItem[],
	userListProfilesDetails: UserDetailsListItem[],
	filterQuery: string
) {
	return pinnedMessages.filter((pinnedMessage) => {
		const targetUser = userListProfilesDetails.find(
			(userProfilesDetails) => isSameUserId(userProfilesDetails?.id, pinnedMessage?.messageSenderId?.userId)
		);

		const targetUserFullName = getUserDisplayName(targetUser);

		return (
			pinnedMessage?.chatMessageId?.message?.toLocaleLowerCase().includes(filterQuery.toLocaleLowerCase()) ||
			targetUserFullName.toLocaleLowerCase().includes(filterQuery.toLocaleLowerCase())
		);
	});
}

export function isChatApproved(chatDetails: ChatListDataInterface, userId: number): boolean {
	const normalizedUserId = toUserId(userId);

	return !chatDetails.pendingApprovalParticipants.some(
		(pendingApprovalParticipant) => isSameUserId(pendingApprovalParticipant.userId, normalizedUserId)
	);
}

export function getAllParticipantsIds(chatListsdetailsData: any[], chatPendingListEndDetailsData: any[]) {
	const allParticipantsIdsFiltered: number[] = [];

	const processParticipants = (participants: any[]) => {
		participants.forEach((participant: any) => {
			if (allParticipantsIdsFiltered.indexOf(participant.userId) === -1) {
				allParticipantsIdsFiltered.push(participant.userId);
			}
		});
	};

	chatListsdetailsData.forEach((chatListItem) => {
		processParticipants(chatListItem.participants);
	});

	chatPendingListEndDetailsData.forEach((chatListItem) => {
		processParticipants(chatListItem.participants);
	});

	return allParticipantsIdsFiltered;
}

export function updateChatList(
	chatListsItems: ChatListDataInterface[],
	newMessage: any,
	chatInFocus: ChatListDataInterface,
	loggedInUserDetails: LoggedInUserDetails,
	dispatch: any
) {
	if (!_.isEmpty(newMessage)) {
		const currentUserId = toUserId(loggedInUserDetails.id);
		const newConversation = chatListsItems.map((con) => {
			const loggedInUserParticipantId = con.participants.find(
				(participant) => isSameUserId(participant.userId, currentUserId)
			)?._id;
			if (con.id === newMessage.chatId) {
				const hasUnreadMessage =
					loggedInUserParticipantId !== newMessage.participantId && newMessage.chatId !== chatInFocus?.id;

				return {
					...con,
					latestAttachment: newMessage.attachments,
					latestMessage: newMessage.message ?? newMessage.body ?? '',
					latestMessageDateTime: newMessage.createdAt,
					unreadCount: hasUnreadMessage ? (con.unreadCount ?? 0) + 1 : con.unreadCount,
				};
			}
			return con;
		});
		return dispatch(chatList(_.orderBy(newConversation, ['latestMessageDateTime'], ['desc'])));
	}
}
